import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PurchaseInterface } from '../purchase.interface';
import { TeamsService, Category } from '../../../services/teams/teams.service';
import { TransactionsService } from '../../../services/transactions/transactions.service';

type PurchaseUpdate = Partial<PurchaseInterface>;

export interface EditPurchaseDialogData {
  teamId: string;
  userId: string;
  purchase: PurchaseInterface;
}

@Component({
  selector: 'app-edit-purchase',
  templateUrl: './edit-purchase.page.html'
})
export class EditPurchasePageComponent implements OnInit {
  form: FormGroup;
  purchaseId!: string;
  teamId!: string;
  userId!: string;
  loaded = false;
  categories: string[] = [];
  selectStyle = { mode: 'md', interface: 'popover' };
  documentImage = '';
  initial: PurchaseUpdate = {};

  constructor(
    private fb: FormBuilder,
    private teamsService: TeamsService,
    private transactionsService: TransactionsService,
    private dialogRef: MatDialogRef<EditPurchasePageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditPurchaseDialogData
  ) {
    this.form = this.fb.group({
      amount: ['', [Validators.required]],
      purchaseDate: ['', [Validators.required]],
      purpose: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]],
      merchant: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]],
      category: [''],
      project: ['', [Validators.minLength(3)]],
      billable: [false]
    });
  }

  ngOnInit(): void {
    this.teamId = this.data.teamId;
    this.userId = this.data.userId;
    this.initFromPurchase(this.data.purchase);
    this.getAndSetTeamCategories();
    this.loaded = true;
  }

  initFromPurchase(p: PurchaseInterface) {
    this.purchaseId = p.id;
    this.documentImage = p.receiptUrl || '';
    this.initial = {
      amount: p.amount,
      purchaseDate: p.purchaseDate,
      purpose: p.purpose,
      merchant: p.merchant,
      category: p.category,
      project: p.project,
      billable: p.billable
    };
    this.form.patchValue({
      amount: p.amount || '',
      purchaseDate: p.purchaseDate || '',
      purpose: p.purpose || '',
      merchant: p.merchant || '',
      category: p.category || '',
      project: p.project || '',
      billable: !!p.billable
    });
  }

  getAndSetTeamCategories(): void {
    this.teamsService.getCategories().then((categories: Category[]): void => {
      this.categories = categories.map((c: Category) => c.name);
    });
  }

  setVal(val: any, field: string) {
    const c = this.form.get(field);
    if (c) c.setValue(val);
  }

  showError(field: string, msg: string): string {
    const c = this.form.get(field);
    return c && c.touched && c.invalid ? msg : '';
  }

  photoTakenEvent(_: any) { }

  saveClicked() {
    if (!this.form.valid) return;
    const v = this.form.value;
    const curr: PurchaseUpdate = {
      amount: String(v.amount || ''),
      purchaseDate: new Date(v.purchaseDate).toISOString().split('T')[0],
      purpose: String(v.purpose || ''),
      merchant: String(v.merchant || ''),
      category: String(v.category || ''),
      project: String(v.project || ''),
      billable: v.billable ? 1 : 0
    };
    const data: PurchaseUpdate = {};
    (Object.keys(curr) as (keyof PurchaseUpdate)[]).forEach(k => {
      if (curr[k] !== this.initial[k]) data[k] = curr[k];
    });
    if (Object.keys(data).length === 0) { this.dialogRef.close(null); return; }
    this.transactionsService.updatePurchase(this.teamId, this.userId, this.purchaseId, data)
      .then(res => this.dialogRef.close(res));
  }

  close() { this.dialogRef.close(); }
}
